import { CriteriaConfig, CriteriaDataTypes, SelectEntities } from './criteriaConfig.types'
import { CriteriaLogic } from './entities'

export const criteriaConfigData: Record<CriteriaLogic, CriteriaConfig> = {
  [CriteriaLogic.organizationHeadquarters]: {
    id: CriteriaLogic.organizationHeadquarters,
    dataType: CriteriaDataTypes.select,
    display: {
      label: 'Headquarters location',
      placeholder: 'Include cities, countries or regions',
    },
    config: { isMulti: true, entity: SelectEntities.location },
  },
  [CriteriaLogic.negativeOrganizationHeadquarters]: {
    id: CriteriaLogic.negativeOrganizationHeadquarters,
    dataType: CriteriaDataTypes.select,
    display: {
      label: 'Headquarters location cannot be',
      placeholder: 'Include cities, countries or regions',
    },
    config: { isMulti: true, entity: SelectEntities.location },
  },
  [CriteriaLogic.organizationStage]: {
    id: CriteriaLogic.organizationStage,
    dataType: CriteriaDataTypes.select,
    display: {
      label: 'Last funding event',
      placeholder: 'Pre-Seed, Series B, IPO...',
    },
    config: { isMulti: true, entity: SelectEntities.stage },
  },
  [CriteriaLogic.organizationFoundedAt]: {
    id: CriteriaLogic.organizationFoundedAt,
    dataType: CriteriaDataTypes.yearRangeSelect,
    display: {
      label: 'Organization founded at',
      description: 'founded date',
    },
  },
}
